import React, { useContext, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Text, Stack } from '@bingads-webui-react/fabric-control';
import { Toggle } from '@bingads-webui-react/fabric-with-signal';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { HelpPopup } from '@bingads-webui-react/help-popup';

export const ToggleTitle = (props) => {
  const i18n = useContext(I18nContext);
  const {
    titleKey, topicKey, handleChangeToggle, isChecked, isActive, id,
  } = props;

  const labeContent = (
    <Stack horizontal tabIndex="0" onClick={(e) => { e.stopPropagation(); }} onKeyPress={(e) => { e.stopPropagation(); }}>
      {i18n.getString(titleKey)}
      {topicKey && <HelpPopup
        topic={topicKey}
        aria-label={i18n.getString(_TL_('Click to learn more about {{item}}'), { item: titleKey })}
      />}
    </Stack>
  );

  const onChange = (e, value) => {
    if (isActive || (!isActive && isChecked)) {
      e.stopPropagation();
    }
    handleChangeToggle(e, value);
  };

  return (
    <Fragment>
      <Stack>
        <Toggle
          {...id === '' ? {}: { id }}
          inlineLabel
          label={labeContent}
          onChange={onChange}
          checked={isChecked}
          className="collapse-title"
        />
        <Stack styles={{ root: { marginLeft: '49px', marginTop: 0 } }} className={isActive ? 'hide' : ''}>
          <Text
            block
            nowrap
            styles={{
              root: {
                lineHeight: '24px',
                maxWidth: '100%',
                paddingTop: props.details ? '8px' : 0,
              },
            }}
            className={classNames(isChecked ? '' : 'inactive-text', 'title-text')}
            title={props.details}
          >
            {props.details}
          </Text>
        </Stack>
      </Stack>

    </Fragment>
  );
};

ToggleTitle.propTypes = {
  id: PropTypes.string,
  details: PropTypes.string,
  titleKey: PropTypes.string.isRequired,
  topicKey: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  handleChangeToggle: PropTypes.func.isRequired,
  isChecked: PropTypes.bool,
};

ToggleTitle.defaultProps = {
  id: '',
  details: '',
  isActive: false,
  isChecked: false,
};
